<template>
  <v-dialog v-model="localDialog" max-width="400" lazy>
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>
          {{ $t('titles.global.confirmation') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('update:dialog', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <span class="subheading">{{ $t('titles.global.confirmClone') }}</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="$emit('update:dialog', false)" />
        <meta-button type="clone" @click="$emit('clone')" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogClone',
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    dialog: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    localDialog: {
      get() {
        return this.dialog
      },
      set() {
        this.$emit('update:dialog', false)
      },
    },
  },
}
</script>
